function getThumbPosition(min, max, value) {
  const position = (value - min) * 100 / (max - min);
  return position + "%";
}
export {
  getThumbPosition
};
//# sourceMappingURL=getThumbPosition.js.map
